import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'

import { useAppSelector } from 'redux/hooks'

import { HUMAN_GAME } from 'types/deck'

import RequestService from 'services/request.service'
import ToastService from 'services/toast.service'

import SimpleSpinner from 'components/elements/SimpleSpinner'
import Select from 'components/formElements/SemanticSelect'

import { humanReadableObjectToDropdown } from 'utils/DropdownConversions'

import styles from './addToCollectionMultiSelect.module.scss'

type Props = {
  onAdded: () => void
}

const AddToCollectionMultiSelect = ({ onAdded }: Props) => {
  const multiSelectedIds = useAppSelector(state => state.active.multiSelectedIds)
  const cardMap = useAppSelector(state => state.deck.cardMap)

  const [loading, setLoading] = useState(false)
  const [addCardsAsNew, setAddCardsAsNew] = useState(true)
  const [game, setGame] = useState(HUMAN_GAME.Paper)

  const handleAddToCollection = () => {
    const cardsToAdd = Object.values(cardMap)
      .filter(card => multiSelectedIds[card.id])
      .map(card => ({
        card: card.cardId,
        quantity: card.qty,
        foil: card.modifier === 'Foil',
        modifier: card.modifier,
        language: 1,
        condition: 1,
        tags: [],
        addOption: addCardsAsNew ? 'Create' : 'Update',
        game: game,
      }))

    setLoading(true)

    return RequestService.post('/api/collection/create/', cardsToAdd)
      .then(() => {
        ToastService.create(
          `Added ${Object.keys(multiSelectedIds).length} card(s) to your collection`,
          'Collection',
          'success',
        )

        onAdded()
      })
      .catch(() => ToastService.create('Unable to add cards to your collection', 'Collection', 'error'))
      .finally(() => setLoading(false))
  }

  return (
    <div>
      <div>Bulk add {Object.keys(multiSelectedIds).length} card(s) to your collection</div>
      <Select
        value={addCardsAsNew}
        onChange={setAddCardsAsNew}
        options={[
          { text: 'Add all cards as new collection records', value: true },
          { text: 'Update existing collection records if they exist', value: false },
        ]}
      />
      <Select
        selection
        name="game"
        fluid
        options={humanReadableObjectToDropdown(HUMAN_GAME)}
        onChange={setGame}
        value={game}
      />

      <div className={styles.controls}>
        <Button
          disabled={loading}
          positive
          icon="plus"
          labelPosition="right"
          content="Add to my collection"
          onClick={handleAddToCollection}
        />
        {loading && <SimpleSpinner size="tiny" />}
      </div>
    </div>
  )
}

export default AddToCollectionMultiSelect
